import React from 'react';
import { Formik, Form } from 'formik';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import { CopyLinkButton, FormGroupControl } from '@components/Base';
import { otpTokenFetch } from './action';
import { selectOtpLink } from './selector';
import { ServerError } from '@components/Helper';

const GROUP_PROPS = { className: 'mb-3' };

const OtpLink = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { otpResetUrl, errors } = useSelector(selectOtpLink);

  return (
    <section>
      <h5 className="mb-4">{t('otp.generateLink')}</h5>

      <Formik
        initialValues={{ username: '' }}
        onSubmit={(values, { setSubmitting }) => {
          dispatch(otpTokenFetch(values));
          setSubmitting(false);
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <FormGroupControl required name="username" label={t('user.username')} groupProps={GROUP_PROPS} />

            <div className="d-flex justify-content-between align-items-center my-3">
              <code>{otpResetUrl}</code>
              {otpResetUrl && <CopyLinkButton link={otpResetUrl} />}
            </div>

            <Button type="submit" disabled={isSubmitting}>
              {t('otp.generateLink')}
            </Button>

            <ServerError errors={errors} />
          </Form>
        )}
      </Formik>
    </section>
  );
};

export { OtpLink };
